// --------------------------------------------------------------
// Created On: 2026-07-22
// Author: Hannah Vaughan
//
// Last Modified: 2026-08-05
// Modified By: Hannah Vaughan
//
// Copyright 2026 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import styles from "./DigitalOutputControls.module.scss";
import PanelSection from "../PanelSection/PanelSection";

// Container for one digital output control in the Remote Operation Panel.
export default function DigitalOutputControls(props: Props): Component {
  return (
    <PanelSection label={`${props.operationLabel} (DO #${props.position})`}>
      <div className={`col px-3 ${styles.controlColumn}`}>
        <button
          className="btn btn-success w-100"
          type="button"
          disabled={props.disabled}
          onClick={() => props.onChangeDigitalOutput(props.position, true)}
        >
          {props.trueLabel.toUpperCase()}
        </button>
      </div>
      <div className={`col px-3 ${styles.controlColumn}`}>
        <button
          className="btn btn-danger w-100"
          type="button"
          disabled={props.disabled}
          onClick={() => props.onChangeDigitalOutput(props.position, false)}
        >
          {props.falseLabel.toUpperCase()}
        </button>
      </div>
    </PanelSection>
  );
}

interface Props {
  position: number;
  operationLabel: string;
  trueLabel: string;
  falseLabel: string;
  disabled: boolean;
  onChangeDigitalOutput: (position: number, state: boolean) => void;
}
